import { Button, Spinner } from '@monksflow/monks-ui';
import { CheckIcon, UsersIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { TruncatedText } from '@/shared/ui/TruncatedText';

export interface RoleApproverRowProps {
  roleName: string;
  /** True when the caller holds the role here and has no row of their own to approve from. */
  canApprove: boolean;
  isMutating: boolean;
  isPending: boolean;
  onApprove: () => void;
}

/** The step's role, standing for whoever holds it in the project when the asset is reviewed. */
export function RoleApproverRow(props: RoleApproverRowProps) {
  const { t } = useTranslation('projects');

  return (
    <li
      className="flex min-h-8 items-center justify-between gap-2"
      data-testid="approval-timeline-role"
    >
      <div className="flex min-w-0 items-center gap-2">
        <span className="flex size-5 shrink-0 items-center justify-center rounded-full bg-surface-tertiary">
          <UsersIcon aria-hidden className="size-3" />
        </span>
        <TruncatedText
          value={t('approveAssetStep.approvalTimeline.anyoneWithRole', { role: props.roleName })}
          className="text-sm text-muted-foreground"
        />
      </div>
      {props.canApprove && (
        <Button
          variant="outline"
          size="mini"
          className="shrink-0"
          disabled={props.isMutating}
          onClick={props.onApprove}
          data-testid="approval-timeline-approve-through-role"
        >
          {props.isPending ? <Spinner className="size-3" /> : <CheckIcon className="size-3" />}
          {t('approveAssetStep.approvalTimeline.approve')}
        </Button>
      )}
    </li>
  );
}
